export default (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    minHeight: 60,
    height: 60,
    maxHeight: 60,
    borderRadius: theme.radius.sm,
  },
  nextUpPaper: {
    backgroundColor: theme.palette.facet.accentBlue20,
  },
  disabledPaper: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  icon: {
    marginRight: theme.spacing(1.5),
    color: theme.palette.facet.mediumGray,
  },
  iconNextUp: {
    color: theme.palette.primary.main,
  },
  primaryText: {},
  iconDisabled: {
    color: theme.palette.facet.primaryGray2,
  },
  textContent: {
    flexGrow: 1,
    minWidth: 0,
  },
  timer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 75,
    minWidth: 75,
    whiteSpace: 'nowrap',
  },
  timerIcon: {
  },
  chevron: {
    color: theme.palette.facet.primaryGray2,
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      boxShadow: theme.shadows[1],
    },
    '&:focus-within': {
      boxShadow: theme.shadows[1],
      outline: 'none',
    },
  },
  spacer: {
    marginLeft: theme.spacing(3),
  },
  secondaryText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  check: {
    margin: theme.spacing(0, 1),
  },
  inProgress: {
    minWidth: 80,
  },
  compactPaper: {
    minWidth: 48,
    minHeight: 48,
    height: 48,
    justifyContent: 'center',
    borderRadius: '100%',
    marginTop: 6,
    marginBottom: theme.spacing(2) + 6,

    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  expandedPaper: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  compactIcon: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: theme.spacing(4),
    marginRight: 0,
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  expanded: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    opacity: 1,
  },
  compact: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    opacity: 0,
  },
  loadingIndicator: {
    margin: theme.spacing(0, 1),
  },
});
